import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import moment from "moment";
import Spinner from 'react-bootstrap/Spinner';
import Stock_navbar from './StockNavbar';

const IssueItems = () => {
    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [StockItem, setStockItem] = useState({});
    const [inOutType, setInOutType] = useState("OUT");
    const [quantity, setQuantity] = useState("");
    const [price, setPrice] = useState("");

    let params = useParams();
    const [ItemID] = useState(params.id);
    let navigate = useNavigate();

    useEffect(() => {
        document.title = "Issue / Receive Stock Items";
        axios({
            method: 'post',
            url: config.base_url + 'Stock/GetStockItemByID',
            headers: { 'Content-Type': 'application/json' },
            data: {
                AccessKey: AccessKey,
                UserID: UserID,
                MemberType: MemberType,
                ID: ItemID
            }
        })
            .then(function (response) {
                if (response.data.status_code == 1) {
                    setStockItem(response.data.StockItem);
                    if (response.data.StockItem.Price_Per_Unit != null) {
                        setPrice(String(response.data.StockItem.Price_Per_Unit));
                    }
                }
            })
            .catch(function () {
                toast.error('Network Error..', { position: toast.POSITION.TOP_RIGHT });
            });
    }, [ItemID, AccessKey, UserID, MemberType]);

    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            setValidated(true);
            return;
        }

        const qty = parseFloat(quantity);
        if (!quantity || Number.isNaN(qty) || qty <= 0) {
            toast.error('Please enter a valid quantity.', { position: toast.POSITION.TOP_RIGHT });
            setValidated(true);
            return;
        }

        if (!inOutType) {
            toast.error('Please select IN or OUT.', { position: toast.POSITION.TOP_RIGHT });
            setValidated(true);
            return;
        }

        const itemIn = inOutType === "IN" ? qty : 0;
        const itemOut = inOutType === "OUT" ? qty : 0;

        if (inOutType === "OUT" && StockItem.Current_Balance != null && qty > Number(StockItem.Current_Balance)) {
            toast.error(
                `Cannot issue ${qty} units. Available balance is ${StockItem.Current_Balance}.`,
                { position: toast.POSITION.TOP_RIGHT }
            );
            return;
        }

        setLoading(true);
        axios({
            method: 'post',
            url: config.base_url + 'Stock/AddItemDetail',
            headers: { 'Content-Type': 'application/json' },
            data: {
                AccessKey: AccessKey,
                UserID: UserID,
                MemberType: MemberType,
                Dated: event.target.txtDated.value,
                Description: event.target.txtDescription.value,
                Custodian: event.target.txtCustodian.value,
                Stock_Price: event.target.txtPrice.value,
                Item_ID: ItemID,
                Item_Out: itemOut,
                Item_In: itemIn,
                Use_Detail: event.target.txtUse_Detail.value,
            }
        })
            .then(function (response) {
                if (response.data.status_code == 1) {
                    toast.success(response.data.status_message, { position: toast.POSITION.TOP_RIGHT });
                    navigate('/StockManagement/ManageStockCategory');
                } else {
                    toast.error(response.data.status_message, { position: toast.POSITION.TOP_RIGHT });
                }
                setLoading(false);
            })
            .catch(function () {
                setLoading(false);
                toast.error('Network Error..', { position: toast.POSITION.TOP_RIGHT });
            });

        setValidated(true);
    };

    return (
        <>
            <Stock_navbar />
            <ToastContainer />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"><Link to="/StockManagement/StocksDashboard">Stocks</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Issue Or Receive Stock Items</li>
                                </ol>
                            </nav>
                            <div className="page-title">Issue Or Receive Stock Items</div>
                        </div>
                        <div className="col-md-6">
                            <div className="page-right-actions">
                                <Link to="/StockManagement/ManageStockCategory" className="button button-white button-icon">
                                    Manage Stock
                                    <i className="ri-list-check"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-content">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body p-md-4">
                                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                        <div className="row align-items-center">
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="">Stock Code:</label>
                                                    <input type="text" disabled defaultValue={StockItem.Stock_Code} className="form-control" required name="txtStock_Code" />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="" className="">Item Name:</label>
                                                    <input type="text" disabled defaultValue={StockItem.Item_Name} className="form-control" required name="txtItem_Name" />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="" className="">Register Type:</label>
                                                    <input type="text" disabled defaultValue={StockItem.Register_Type} className="form-control" required name="txtItem_Name" />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label>Current balance:</label>
                                                    <input type="text" disabled value={StockItem.Current_Balance ?? ""} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="" className="">Dated:</label>
                                                    <input type="date" defaultValue={moment().format(config.date_format_input)} className="form-control" required name="txtDated" />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="" className="">Quantity:</label>
                                                    <input type="number" min="0.01" step="any" value={quantity} onChange={(e) => setQuantity(e.target.value)} className="form-control" required name="txtQuantity" />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="" className="">Price:</label>
                                                    <input type="number" min="0" step="any" value={price} onChange={(e) => setPrice(e.target.value)} className="form-control" required name="txtPrice" />
                                                </div>
                                            </div>

                                            <div className="col-md-2">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="" className="">Type:</label>
                                                    <select className="form-select" name="ddlInOut"
                                                        value={inOutType}
                                                        onChange={(e) => setInOutType(e.target.value)}
                                                        required>
                                                        <option value="">Select Type</option>
                                                        <option value="IN">IN (Receive)</option>
                                                        <option value="OUT">OUT (Issue)</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="" className="">Custodian:</label>
                                                    <input type="text" defaultValue={StockItem.Main_Custodian || ""} className="form-control" required name="txtCustodian" />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="" className="">Description:</label>
                                                    <input type="text" defaultValue={StockItem.Description} className="form-control" required name="txtDescription" />
                                                </div>
                                            </div>
                                            <div className="col-md-10">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="" className="">Usage Details:</label>
                                                    <input type="text" defaultValue={StockItem.Use_Detail} className="form-control" required name="txtUse_Detail" />
                                                </div>
                                            </div>
                                            <div className="col-md-2 mt-md-2">
                                                <div className="form-group ">
                                                    {
                                                        loading ?
                                                            <Spinner animation="border" role="status"></Spinner>

                                                            :
                                                            <button type="submit" value="Save" className="button button-primary w-100 ">SAVE</button>

                                                    }

                                                </div>
                                            </div>

                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default IssueItems;
